import React, { useContext, useEffect, useState } from 'react';
import SelectOption from '../OptionAddCollaborator/SelectOption/SelectOption';

import { ReactComponent as XIcon } from '../../assets/icons/XIcon.svg';

import classes from './OptionAddSuppliers.module.scss';
import AsyncLoad from '../AsyncLoad/AsyncLoad';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Context from '../../store/context';
import { paths } from '../../routes';
import SomeSuppliers from './SomeSuppliers/SomeSuppliers';
import useFetch from '../../services/hooks/http/useFetch';
import apiMethods from '../../apis';
import utils from '../../services/utils';
import { Storage } from 'aws-amplify';

const stepsAyncLoad = [{ stepTitle: 'Subiendo archivo' }, { stepTitle: 'Creando proveedores' }];

const initValues = {
  fileUpload: null,
  errorMessageAsyncLoad: null,
  currentStep: 0,
  filesStates: [],
  currentStepAsyncLoad: 0,
  isAsyncLoad: false
};

const OptionAddSuppliers = () => {
  const {
    // toast: { showSuccess },
    modal: { showError },
    supplier: { hideAddSupplier, visible, isCloseVisible }
  } = useContext(Context);

  const navigate = useNavigate();

  const {
    isSuccess: createSuccess,
    sendRequest: createSupplierssByFile,
    isError: createError,
    data: createSupplierData,
    errorMessage
  } = useFetch(apiMethods.createSuppliersByFile);

  const [isAsyncLoad, setAsyncLoad] = useState(initValues.isAsyncLoad);

  const { businessId } = useSelector(state => state.userData);

  const [showModal, setShowModal] = useState(visible);

  const [fileUpload, setFileUpload] = useState(initValues.fileUpload);

  const [errorMessageAsyncLoad, setErrorMessageAsyncLoad] = useState(initValues.errorMessageAsyncLoad);

  const [currentStep, setCurrentStep] = useState(initValues.currentStep);

  const [filesStates, setFilesStates] = useState(initValues.filesStates);

  const [currentStepAsyncLoad, setCurrentStepAsyncLoad] = useState(initValues.currentStepAsyncLoad);

  useEffect(() => {
    const getStatusCreateSuppliers = async () => {
      await utils.promiseLoop(
        async () => {
          const result = await apiMethods.getSuppliersBatchCreationById[1](createSupplierData.suppliersbatchId);
          return result?.body;
        },
        supplier => {
          const isProcessFinished = supplier.status === 'FINISHED';
          setFilesStates(files => {
            const auxFiles = [...files];
            auxFiles[0] = { ...auxFiles[0], state: supplier.status };
            return auxFiles;
          });
          supplier.state === 'ERROR' && setErrorMessageAsyncLoad(supplier.stateMessage);
          isProcessFinished &&
            setTimeout(() => {
              setFileUpload(initValues.fileUpload);
              setErrorMessageAsyncLoad(initValues.errorMessageAsyncLoad);
              setCurrentStep(initValues.currentStep);
              setFilesStates(initValues.filesStates);
              setCurrentStepAsyncLoad(initValues.currentStepAsyncLoad);
              setAsyncLoad(initValues.isAsyncLoad);
            }, 10000);
          return { isProcessFinished };
        }
      );
    };
    if (createSuccess) {
      getStatusCreateSuppliers();
    } else if (createError) {
      setErrorMessageAsyncLoad('Error al crear los colaboradores');
    }
  }, [createSupplierData, createError, createSuccess, errorMessage, showError]);

  const optionSelected = option => {
    if (option === 'one') {
      navigate(paths.addSupplier);
      //hideAddCollaborator();
      hideAddSupplier();
    } else {
      setCurrentStep(1);
    }
  };

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  const containerClasses = [classes.container];
  if (visible) {
    containerClasses.push(classes.visible);
  }

  const modalClasses = [classes.modal];
  if (showModal) {
    modalClasses.push(classes['modal-visible']);
  }

  const closeHandler = () => {
    setFileUpload(initValues.fileUpload);
    setCurrentStep(initValues.currentStep);
    setShowModal(false);
    hideAddSupplier();
    setTimeout(() => hideAddSupplier(), 250);
  };

  const backButtonHandler = () => {
    setFileUpload(initValues.fileUpload);
    setCurrentStep(initValues.currentStep);
  };

  const uploadFiles = async (path, format) => {
    try {
      hideAddSupplier();
      setFilesStates([
        {
          fileName: fileUpload.name,
          format,
          state: 'PROCESSING'
        }
      ]);
      setAsyncLoad(true);
      await Storage.put(path, fileUpload);
      setCurrentStepAsyncLoad(1);
      createSupplierssByFile(businessId, path);
    } catch (error) {
      console.error('Error al subir archivo:', error);
      setFilesStates([
        {
          fileName: fileUpload.name,
          format,
          state: 'ERROR'
        }
      ]);
      //showError({ title: 'Subiendo archivos', description: 'Error al subir los archivos S3' });
      setErrorMessageAsyncLoad('Error al subir los archivos a S3');
    }
  };

  return !isAsyncLoad ? (
    <div className={containerClasses.join(' ')}>
      <div className={modalClasses.join(' ')}>
        {isCloseVisible && (
          <div className={`pointer ${classes.close}`} onClick={closeHandler}>
            <span>Cerrar</span>
            <XIcon className={classes.icon} />
          </div>
        )}

        <>
          {currentStep === 0 && <SelectOption optionSelected={optionSelected} type='supplier' />}
          {currentStep === 1 && (
            <SomeSuppliers
              backButtonHandler={backButtonHandler}
              fileUpload={fileUpload}
              setFileUpload={setFileUpload}
              setCurrentStep={setCurrentStep}
              optionSelected={optionSelected}
              uploadFiles={uploadFiles}
            />
          )}
        </>
      </div>
    </div>
  ) : (
    <div className={classes.async}>
      <AsyncLoad
        globalState={!!errorMessageAsyncLoad}
        errorMessage={errorMessageAsyncLoad}
        steps={stepsAyncLoad}
        files={filesStates}
        currentStep={currentStepAsyncLoad}
      />
    </div>
  );
};

export default OptionAddSuppliers;
